import * as React from "react";
import { useMemo } from "react";
import { DocumentData } from "../config/firebase";

const { useState } = React;
interface SessionContextTypes {
  isReady: boolean;
  setIsReady: React.Dispatch<React.SetStateAction<boolean>>;
  setUser: React.Dispatch<React.SetStateAction<DocumentData | null>>;
  user: DocumentData | null;
  setAnswers: React.Dispatch<React.SetStateAction<DocumentData[] | null>>;
  answers: DocumentData[] | null;
}
const TestContext = React.createContext({} as SessionContextTypes);
export default TestContext;

type Props = {
  children: React.ReactNode;
};

const TestProvider = ({ children }: Props) => {
  const [isReady, setIsReady] = useState(false);
  const [user, setUser] = useState<DocumentData | null>(null);
  const [answers, setAnswers] = useState<DocumentData[] | null>(null);

  const value = useMemo(
    () => ({
      isReady,
      setIsReady,
      user,
      setUser,
      answers,
      setAnswers,
    }),
    [isReady, user, answers, setAnswers]
  );

  return <TestContext.Provider value={value}>{children}</TestContext.Provider>;
};
export { TestProvider };
